import { render, staticRenderFns } from "./PartnershipAdsBrandView.vue?vue&type=template&id=27cacc2e&scoped=true"
import script from "./PartnershipAdsBrandView.vue?vue&type=script&lang=js"
export * from "./PartnershipAdsBrandView.vue?vue&type=script&lang=js"
import style0 from "./PartnershipAdsBrandView.vue?vue&type=style&index=0&id=27cacc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cacc2e",
  null
  
)

export default component.exports